function _(r,s,n){class e extends Error{}n.AssertionError=e,e.__name__="AssertionError",n.assert=function(r,s){if(!(!0===r||!1!==r&&r()))throw new e(s||"Assertion failed")}}
//# sourceMappingURL=assert.min.js.map